/*
 * @Description: 路由配置
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: lizhen 614103669@qq.com
 * @LastEditTime: 2022-05-17 17:41:49
 */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import shopingLayout from '@/shopingLayout'
import storeLayout from '@/storeLayout'
import store from '@/store/index'

Vue.use(Router)

/** =====商城页面路由===== */
export const shopingRoutes = [{
  path: '/',
  redirect: '/Home',
  component: shopingLayout,
  hidden: true,
  children: [{
    path: 'home',
    name: 'Home',
    component: () => import('@/views/shopingMall/home/index.vue'),
    meta: {
      title: '首页',
      icon: 'dashboard',
      showFooter: true,
      affix: true,
      activeMenu: 'true',
      requireAuth: false // 需要登陆
    }
  }]
},
{
  path: '/shop',
  component: shopingLayout,
  redirect: '/shop/shoppingCart',
  name: 'shoppingCart',
  hidden: true,
  meta: {
    title: '购物车',
    keepAlive: true
  },
  children: [{
    path: 'shoppingCart',
    name: 'shoppingCart',
    component: () => import('@/views/shopingMall/shoppingCart/index'),
    meta: {
      title: '购物车',
      requireAuth: true, // 需要登陆
      keepAlive: true
    }
  }]
},
{
  path: '/submitOrder',
  component: shopingLayout,
  redirect: '/submitOrder/submitOrderList',
  name: '提交订单',
  hidden: true,
  meta: {
    title: '提交订单'
  },
  children: [{
    path: 'submitOrderList',
    name: 'submitOrderList',
    component: () => import('@/views/shopingMall/submitOrder/index'),
    meta: {
      title: '提交订单',
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/search',
  component: shopingLayout,
  redirect: '/search/searchPage',
  name: '搜索结果页',
  hidden: true,
  meta: {
    title: '搜索结果页',
    keepAlive: true
  },
  children: [{
    path: 'searchPage',
    name: 'searchPage',
    component: () => import('@/views/shopingMall/searchPage/index'),
    meta: {
      title: '搜索结果页',
      requireAuth: true, // 需要登陆
      showFooter: true
    }
  }]
},
{
  path: '/search',
  component: shopingLayout,
  redirect: '/search/supplierPage',
  name: '搜索结果页',
  hidden: true,
  meta: {
    title: '搜索结果页',
    showFooter: true
  },
  children: [{
    path: 'supplierPage',
    name: 'supplierPage',
    component: () => import('@/views/shopingMall/supplierPage/index'),
    meta: {
      title: '搜索结果页',
      requireAuth: true, // 需要登陆
      showFooter: true
    }
  }]
},
{
  path: '/error',
  name: 'Error',
  hidden: true,
  component: () => import('@/components/Error.vue')
},
{
  path: '/login/login',
  name: 'Login',
  hidden: true,
  component: () => import('@/views/login/login/index.vue')
},
{
  path: '/login/forget-password',
  name: 'forget-password',
  hidden: true,
  component: () => import('@/views/login/forget-password/index.vue')
},
{
  path: '/login/register',
  name: 'register',
  hidden: true,
  component: () => import('@/views/login/register/index.vue')
}
]
/** ====需方后台页面路由==== */
export const manageMentRoutes = [{
  path: '/department',
  component: Layout,
  redirect: '/department/departmentManagement',
  name: '部门管理',
  hidden: false,
  meta: {
    title: '部门管理'
  },
  children: [{
    path: 'department',
    name: 'department',
    component: () => import('@/views/manageMent/department'),
    meta: {
      title: '部门管理',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/permission',
  component: Layout,
  redirect: '/permission',
  name: '人员管理',
  hidden: false,
  meta: {
    title: '人员管理'
  },
  children: [{
    path: 'permissionManage',
    name: 'permissionManage',
    component: () => import('@/views/manageMent/permissionManage'),
    meta: {
      title: '人员管理',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/approvalProcess',
  component: Layout,
  redirect: '/approvalProcess',
  // name: '审批流程',
  name: '审批设置',
  hidden: false,
  meta: {
    title: '审批设置'
  },
  children: [{
    path: 'approvalProcess',
    name: 'approvalProcess',
    component: () => import('@/views/manageMent/approvalProcess'),
    meta: {
      title: '审批设置',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
// {
//   path: '/reportForms',
//   component: Layout,
//   redirect: '/reportForms',
//   name: '数据报表',
//   hidden: false,
//   meta: {
//     title: '数据报表'
//   },
//   children: [{
//     path: 'reportForms',
//     name: 'reportForms',
//     component: () => import('@/views/manageMent/reportForms'),
//     meta: {
//       title: '数据报表',
//       showFooter: false,
//       showSiderBar: true,
//       requireAuth: true // 需要登陆
//     }
//   }]
// },
{
  path: '/wallet',
  component: Layout,
  redirect: '/wallet',
  name: '钱包',
  hidden: false,
  meta: {
    title: '钱包'
  },
  children: [{
    path: 'wallet',
    name: 'wallet',
    component: () => import('@/views/manageMent/wallet'),
    meta: {
      title: '钱包',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/statement',
  component: Layout,
  redirect: '/statement',
  name: '对账单',
  hidden: false,
  meta: {
    title: '对账单'
  },
  children: [{
    path: 'statement',
    name: 'statement',
    component: () => import('@/views/manageMent/statement'),
    meta: {
      title: '对账单',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/accountSettings',
  component: Layout,
  redirect: '/accountSettings',
  name: '账号设置',
  hidden: false,
  meta: {
    title: '账号设置'
  },
  children: [{
    path: 'accountSettings',
    name: 'accountSettings',
    component: () => import('@/views/manageMent/accountSettings'),
    meta: {
      title: '账号设置',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/merchandise',
  component: Layout,
  redirect: '/merchandise',
  name: '收藏商品',
  hidden: false,
  meta: {
    title: '收藏商品'
  },
  children: [{
    path: 'merchandise',
    name: 'merchandise',
    component: () => import('@/views/manageMent/merchandise'),
    meta: {
      title: '收藏商品',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/address',
  component: Layout,
  redirect: '/address/myAddress',
  name: '我的地址',
  showHome: false, // 如果是true，则在商城首页的用户中心里显示
  hidden: false,
  meta: {
    title: '我的地址'
  },
  children: [{
    path: 'myAddress',
    name: 'MyAddress',
    component: () => import('@/views/manageMent/myAddress/index'),
    meta: {
      title: '我的地址',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/historical',
  component: Layout,
  redirect: '/historical',
  name: '浏览记录',
  hidden: false,
  meta: {
    title: '浏览记录'
  },
  children: [{
    path: 'historical',
    name: 'historical',
    component: () => import('@/views/manageMent/historical'),
    meta: {
      title: '浏览记录',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
// {
//   path: '/recharge',
//   component: Layout,
//   redirect: '/recharge/onlineRecharge',
//   name: '在线充值',
//   hidden: false,
//   meta: {
//     title: '在线充值'
//   },
//   children: [{
//     path: 'onlineRecharge',
//     name: 'onlineRecharge',
//     // component: () => import('@/views/onlineRecharge/index'),
//     meta: {
//       title: '在线充值',
//       showFooter: false,
//       showSiderBar: true,
//       requireAuth: true // 需要登陆
//     }
//   }]
// },
// 新增订单管理
{
  path: '/order',
  component: Layout,
  redirect: '/order/orderManagement',
  name: '订单管理',
  hidden: false,
  meta: {
    title: '订单管理'
  },
  children: [{
    path: 'orderManagement',
    name: 'MyOrderManagement',
    component: () => import('@/views/manageMent/orderManagement/index'),
    meta: {
      title: '订单管理',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/approvalQuery',
  component: Layout,
  redirect: '/approvalQuery',
  name: '订单审批',
  hidden: false,
  meta: {
    title: '订单审批'
  },
  children: [{
    path: 'approvalQuery',
    name: 'approvalQuery',
    component: () => import('@/views/manageMent/approvalQuery'),
    meta: {
      title: '订单审批',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/data',
  component: Layout,
  redirect: '/order/dataReport',
  name: '数据报表',
  hidden: false,
  meta: {
    title: '数据报表'
  },
  children: [{
    path: 'dataReport',
    name: 'MyDataReport',
    component: () => import('@/views/manageMent/dataReport/index'),
    meta: {
      title: '数据报表',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/classification',
  component: Layout,
  redirect: '/classification',
  name: '商品分类',
  hidden: false,
  meta: {
    title: '商品分类'
  },
  children: [{
    path: 'orderManagement',
    name: 'MyOrderManagement',
    component: () => import('@/views/manageMent/commodityClassification/index'),
    meta: {
      title: '商品分类',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
// {
//   path: '/afterSale',
//   component: Layout,
//   redirect: '/afterSale',
//   name: '在线充值',
//   hidden: false,
//   meta: {
//     title: '在线充值'
//   },
//   children: [{
//     path: 'onlineRecharge',
//     name: 'onlineRecharge',
//     // component: () => import('@/views/onlineRecharge/index'),
//     meta: {
//       title: '申请售后',
//       showFooter: false,
//       showSiderBar: true,
//       requireAuth: true // 需要登陆
//     }
//   }]
// },
{
  path: '/orderManagement',
  component: Layout,
  redirect: 'orderManagement/evaluate',
  name: '订单评价',
  hidden: true,
  meta: {
    title: '订单评价'
  },
  children: [{
    path: 'evaluate',
    name: 'Evaluate',
    component: () => import('@/views/manageMent/orderManagement/evaluate/index'),
    meta: {
      title: '订单评价',
      showFooter: false,
      showSiderBar: false,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/buy',
  component: Layout,
  redirect: '/buy/postBuyLeads',
  name: '快速求购',
  hidden: false,
  meta: {
    title: '快速求购'
  },
  children: [{
    path: 'postBuyLeads',
    name: 'postBuy-Leads',
    component: () => import('@/views/manageMent/postBuyLeads/index'),
    meta: {
      title: '快速求购',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
{
  path: '/service',
  component: Layout,
  redirect: 'service/service',
  name: '申请售后',
  hidden: true,
  meta: {
    title: '申请售后'
  },
  children: [{
    path: 'service',
    name: 'Service',
    component: () => import('@/views/manageMent/orderManagement/service/index'),
    meta: {
      title: '申请售后',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},
// {
//   path: '/basics',
//   component: Layout,
//   redirect: '/basics/commodityManage',
//   name: '商品管理',
//   showHome: true,
//   hidden: false,
//   meta: {
//     title: '商品管理'
//   },
//   children: [{
//     path: 'commodityManage',
//     name: 'CommodityManage',
//     component: () => import('@/views/manageMent/commodityManage/index'),
//     meta: {
//       title: '商品管理',
//       showFooter: false,
//       showSiderBar: true,
//       requireAuth: true // 需要登陆
//     }
//   }]
// },
{
  path: '/user',
  component: Layout,
  redirect: '/user/user',
  name: '用户中心',
  showHome: false, // 如果是true，则在商城首页的用户中心里显示
  hidden: false,
  meta: {
    title: '用户中心'
  },
  children: [{
    path: 'user',
    name: 'User',
    component: () => import('@/views/manageMent/user/index'),
    meta: {
      title: '用户中心',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
},

{
  path: '/help',
  component: Layout,
  redirect: '/help/helpCenter',
  name: '帮助中心',
  showHome: true, // 如果是true，则在商城首页的用户中心里显示
  hidden: false,
  meta: {
    title: '帮助中心'
  },
  children: [{
    path: 'helpCenter',
    name: 'HelpCenter',
    component: () => import('@/views/manageMent/helpCenter/index'),
    meta: {
      title: '帮助中心',
      showFooter: false,
      showSiderBar: true,
      requireAuth: true // 需要登陆
    }
  }]
}
]
/** ====店铺系统页面路由==== */
export const storeSyetemRoutes = [{
  path: '/store',
  component: storeLayout,
  // redirect: '/store/storeList',
  name: '店铺首页',
  hidden: true,
  meta: {
    title: '店铺首页'
  },
  children: [{
    path: 'storeList',
    name: 'storeList',
    component: () => import('@/views/storeSystem/index/index'),
    meta: {
      title: '店铺首页',
      showFooter: true,
      showSiderBar: false,
      requireAuth: true // 需要登陆
    }
  },
  {
    path: 'commodityList',
    name: 'commodityList',
    component: () => import('@/views/storeSystem/commodity/index'),
    meta: {
      title: '店铺商品',
      showFooter: true,
      showSiderBar: false,
      requireAuth: true // 需要登陆
    }
  },
  {
    path: 'newCommodityList',
    name: 'newCommodityList',
    component: () => import('@/views/storeSystem/newCommodity/index'),
    meta: {
      title: '店铺新品',
      showFooter: true,
      showSiderBar: false,
      requireAuth: true // 需要登陆
    }
  },
  {
    path: 'details',
    name: 'details',
    component: () => import('@/views/shopingMall/detail/index'),
    meta: {
      title: '商品详情',
      showFooter: false,
      requireAuth: true // 需要登陆
    }

  },
  {
    path: 'storeFile',
    name: 'storeFile',
    component: () => import('@/views/storeSystem/storeFile/index'),
    meta: {
      title: '店铺档案',
      requireAuth: true // 需要登陆
    }
  },
  {
    path: 'contactUs',
    name: 'contactUs',
    component: () => import('@/views/storeSystem/contactUs/index'),
    meta: {
      title: '联系我们',
      requireAuth: true // 需要登陆
    }
  }
  ]
}
  //   {
  //     path: '/commodity',
  //     component: storeLayout,
  //     redirect: '/commodity/commodityList',
  //     name: '店铺商品',
  //     hidden: true,
  //     meta: { title: '店铺商品' },
  //     children: [
  //       {
  //         path: 'commodityList',
  //         name: 'commodityList',
  //         component: () => import('@/views/storeSystem/commodity/index'),
  //         meta: {
  //           title: '店铺商品',
  //           showFooter: true,
  //           showSiderBar: false,
  //           requireAuth: true // 需要登陆
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     path: '/newCommodity',
  //     component: storeLayout,
  //     redirect: '/newCommodity/newCommodityList',
  //     name: '店铺新品',
  //     hidden: true,
  //     meta: { title: '店铺新品' },
  //     children: [
  //       {
  //         path: 'newCommodityList',
  //         name: 'newCommodityList',
  //         component: () => import('@/views/storeSystem/newCommodity/index'),
  //         meta: {
  //           title: '店铺新品',
  //           showFooter: true,
  //           showSiderBar: false,
  //           requireAuth: true // 需要登陆
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     path: '/goods',
  //     component: storeLayout,
  //     redirect: '/goods/details',
  //     name: '商品详情',
  //     hidden: true,
  //     meta: { title: '商品详情' },
  //     children: [
  //       {
  //         path: 'details',
  //         name: 'details',
  //         component: () => import('@/views/shopingMall/detail/index'),
  //         meta: {
  //           title: '商品详情',
  //           showFooter: false,
  //           requireAuth: true // 需要登陆
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     path: '/storeFile',
  //     component: storeLayout,
  //     redirect: '/storeFile/storeFile',
  //     name: '店铺档案',
  //     hidden: true,
  //     meta: { title: '店铺档案' },
  //     children: [
  //       {
  //         path: 'storeFile',
  //         name: 'storeFile',
  //         component: () => import('@/views/storeSystem/storeFile/index'),
  //         meta: {
  //           title: '店铺档案',
  //           requireAuth: true // 需要登陆
  //         }
  //       }
  //     ]
  //   },
  //   {
  //     path: '/contactUs',
  //     component: storeLayout,
  //     redirect: '/contactUs/contactUs',
  //     name: '联系我们',
  //     hidden: true,
  //     meta: { title: '联系我们' },
  //     children: [
  //       {
  //         path: 'contactUs',
  //         name: 'contactUs',
  //         component: () => import('@/views/storeSystem/contactUs/index'),
  //         meta: {
  //           title: '联系我们',
  //           requireAuth: true // 需要登陆
  //         }
  //       }
  //     ]
  //   }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [...shopingRoutes, ...manageMentRoutes, ...storeSyetemRoutes]
})
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
router.beforeEach((to, from, next) => {
  if (to.path === '/store' && from.path === '/store/storeList') {
    next('/')
    return
  }
  if (localStorage.getItem('userInfo') == undefined || !document.cookie) {
    if (!localStorage.getItem('userInfo')) {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
    }
    if (!document.cookie) {
      localStorage.removeItem('userInfo')
    }
  }
  if (to.meta.requireAuth) { // 如果需要跳转 ，往下走（1）
    if (localStorage.getItem('userInfo') && document.cookie) { // 判断是否登录过，如果有登陆过，说明有token,或者token未过期，可以跳过登录（2）
      if (to.path === '/login/login') { // 判断下一个路由是否为要验证的路由（3）
        next('/index') // 如果是直接跳到首页，
        return
        // if (!localStorage.getItem('userInfo')) {
        //   next('/index')
        // } else {
        //   next()
        //   var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
        //   if (keys) {
        //     for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
        //   }
        // }
      } else { // 如果该路由不需要验证，那么直接往后走
        // next()
        const {
          fuserId,
          ftype
        } = JSON.parse(localStorage.getItem('userInfo') || JSON.stringify({}))
        const allRoute = router.options.routes.filter(item => !item.hidden && item.meta.title).map(items => items.meta.title)
        const settingRoute = store.getters.routeGather.filter(item => !item.hidden && item.meta.title).map(items => items.meta.title)
        if (allRoute.indexOf(to.meta.title) > -1 && to.meta.title) {
          if (fuserId) {
            if (ftype !== 1) {
              if (settingRoute.indexOf(to.meta.title) < 0) {
                next(false)
                return
              }
            }
          } else {
            next(false)
            return
          }
        }
        next()
      }
    } else {
      //   console.log('没有') // 如果没有登陆过，或者token 过期， 那么跳转到登录页
      next('/login/login')
    }
  } else { // 不需要跳转，直接往下走
    // console.log('不需要登陆')
    next()
  }
})

/* 由于Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理。
vue-router先报了一个Uncaught(in promise)的错误(因为push没加回调) ，然后再点击路由的时候才会触发NavigationDuplicated的错误(路由出现的错误，全局错误处理打印了出来)。*/
// 禁止全局路由错误处理打印
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

export default router
